import { Component, EventEmitter, OnDestroy, OnInit, Output, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { TileCreatorService } from '../../services/tile-creator.service';
import { TILE_REQUEST } from '../../tokens/tile-request.token';

@Component({
  standalone: false,
  selector: 'tender-list-tile-setup-wizard',
  templateUrl: './tender-list-tile-setup-wizard.component.html',
  styleUrls: ['./tender-list-tile-setup-wizard.component.scss'],
})
export class TenderListTileSetupWizardComponent {
  private readonly tileCreatorService = inject(TileCreatorService);
  private readonly destroy$ = new Subject<void>();

  @Output() tempTileDefinitionChanged = new EventEmitter<any>();

  protected readonly tileDefinition = inject(TILE_REQUEST).tileInstance as any;

  private readonly existingConfig = (this.tileDefinition?.config ?? {}) as {
    recipe?: { dataSource?: string };
    itemsPerPage?: number;
  };

  protected readonly formGroup = new FormGroup({
    dataSource: new FormControl<string>(this.existingConfig?.recipe?.dataSource ?? '', {
      nonNullable: true,
      validators: [Validators.required],
    }),
    itemsPerPage: new FormControl<number>(this.existingConfig?.itemsPerPage ?? 5, {
      nonNullable: true,
      validators: [Validators.required, Validators.min(1)],
    }),
  });

  ngOnInit() {
    this.formGroup.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.tempTileDefinitionChanged.emit(this.getChanges());
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getChanges() {
    const dataSource = this.formGroup.controls.dataSource.value;
    const itemsPerPage = Number(this.formGroup.controls.itemsPerPage.value);

    return {
      tileType: 'tender-list-tile',
      canView: true,
      config: {
        ...this.existingConfig,
        recipe: {
          ...(this.existingConfig.recipe ?? {}),
          dataSource,
        },
        itemsPerPage,
      },
    };
  }

  onSubmit() {
    if (this.formGroup.invalid) {
      return;
    }

    Object.assign(this.tileDefinition, this.getChanges());

    this.tileCreatorService.onChange.next();
  }
}
